module.exports = "<p>\r\n  lecture-material works!\r\n</p>\r\n"